import React, { useState } from "react";
import "./Plan_Details_Modal.css";
import { Modal } from "react-bootstrap";
import { faPhone, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RedRoundBtn from "../../Common_Btn/RedRoundBtn/RedRoundBtn";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Know_Your_Plan_Component from "./Know_Your_Plan_Component/Know_Your_Plan_Component";
import Rupee_Lottie from "../../../animation/Rupee_Lottie/Rupee_Lottie";
import Add_On_Benifits_Component from "./Add_On_Benifits_Component/Add_On_Benifits_Component";
import Claim_Support_Component from "./Claim_Support_Component/Claim_Support_Component";
import Download_Component from "./Download_Component/Download_Component";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";

const Plan_Details_Modal = ({ IMG_URL, val, ...props }) => {
  const tab_buttons = [
    "Know your plan",
    "Add-on benefits",
    "Claim Support",
    "Download",
  ];

  const [activeTab, setActiveTab] = useState("Know your plan");
  const navigate = useNavigate();
  return (
    <section className="Plan_Details_Modal">
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Plan_Details_Modal"
      >
        <Modal.Header>
          <div
            className="close_icon_holder"
            onClick={() => {
              props?.onHide();
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>

          <div className="main_header_content">
            <div className="company_logo_holder">
              <img src={`${IMG_URL}${val?.image}`} className="img" />
            </div>

            <div className="row">
              <div className=" col-md-9 col-sm-9 col-12">
                <div className="company_title">
                  <p className="company_name">{val?.name}</p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-12">
                <div className="btn_holder">
                  <RedRoundBtn
                    lefticon={faPhone}
                    btn_name="Get Help"
                    as="a"
                    href="tel:+911234567890" // Replace with actual phone number
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="modal_content">
            <div className="tabs_btn_holder">
              <Swiper
                spaceBetween={15}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                autoplay={{ delay: 300 }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.8,
                    spaceBetween: 10,
                  },
                  350: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  420: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                  },
                  486: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  1400: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                  },
                }}
              >
                {tab_buttons?.map((item) => {
                  return (
                    <SwiperSlide>
                      <div className="tab_button">
                        <div
                          className={`tab ${
                            activeTab === item ? "active" : ""
                          }`}
                        >
                          <p
                            className={"tab_text"}
                            onClick={() => {
                              setActiveTab(item);
                            }}
                          >
                            {item}
                          </p>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              {/* {tab_buttons?.map((item) => {
                                return (
                                      
                                    )
                            })} */}
            </div>

            <div className="tab_container">
              {activeTab === "Know your plan" && (
                <div className="know_your_plan_div">
                  <Know_Your_Plan_Component val={val} IMG_URL={IMG_URL} />
                </div>
              )}

              {activeTab === "Add-on benefits" && (
                <div className="add_on_plan_div">
                  <Add_On_Benifits_Component val={val} IMG_URL={IMG_URL} />
                </div>
              )}

              {activeTab === "Claim Support" && (
                <div className="claim_support_div">
                  <Claim_Support_Component val={val} IMG_URL={IMG_URL} />
                </div>
              )}

              {activeTab === "Download" && (
                <div className="download_div">
                  <Download_Component val={val} IMG_URL={IMG_URL} />
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="modal_footer_content">
            <div className="content_holder">
              <div className="left_side_div">
                <div className="lottie_holder">
                  <Rupee_Lottie />
                </div>
                <p className="price_text">
                  ₹ {val?.f_i_amounts[0]?.online_amount}
                </p>
              </div>
              {/* <Link to={{ pathname: "/plan-purchase", state: { val } }}> */}
              <div
                className="btn_holder"
                onClick={() => {
                  navigate("/plan-purchase", { state: { val } });
                }}
              >
                <RedRoundBtn btn_name="Proceed" />
              </div>
              {/* </Link> */}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default Plan_Details_Modal;
